(function () {
  'use strict';
  function purchasePath(value, origin) {
    try {
      const url = new URL(value, origin);
      return url.origin === origin && /(?:^|\/)(?:checkouts?(?:\/|$)|cart\/add(?:\.js)?\/?$|cart\/\d+:\d+)/.test(url.pathname);
    } catch (_) { return false; }
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { purchasePath };
  if (typeof document === 'undefined') return;
  function block(event) { event.preventDefault(); event.stopImmediatePropagation(); }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (purchasePath(form.action, location.origin) || event.submitter?.name === 'checkout') block(event);
  }, true);
  document.addEventListener('click', event => {
    const target = event.target.closest('a, button, input[type="submit"]');
    if (!target) return;
    if (target.name === 'checkout' || (target.href && purchasePath(target.href, location.origin))) block(event);
  }, true);
  function disable(container) {
    container.querySelectorAll('a[href], form[action], [name="checkout"]').forEach(node => {
      const url = node.getAttribute('href') || node.getAttribute('action');
      if (node.getAttribute('name') !== 'checkout' && !purchasePath(url, location.origin)) return;
      node.dataset.ukPurchaseDisabled = 'true';
      node.setAttribute('aria-disabled', 'true');
      if ('disabled' in node) node.disabled = true;
    });
  }
  disable(document);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) disable(node.parentElement || node);
    }));
  }).observe(document.body, { childList: true, subtree: true });
})();
